import React, { useState } from "react";
import { TextInput as RNTextInput } from "react-native";
import { Device } from "utils";

import { OTHER_TEXT_MAX_LENGTH } from "consts";

export const TextInput = props => {
  const [cursorPosition, setCursorPosition] = useState({ start: 0, end: 0 });

  if (Device.IS_IOS_WEB) {
    return <RNTextInput maxLength={OTHER_TEXT_MAX_LENGTH} {...props} />;
  }

  return (
    <RNTextInput
      maxLength={OTHER_TEXT_MAX_LENGTH}
      {...props}
      selection={cursorPosition}
      onSelectionChange={e => setCursorPosition(e.nativeEvent.selection)}
    />
  );
};
